module.exports = __webpack_public_path__ + "img/virus.723da1d9.png";